<template>
  <div class="main-wrapper">
    <!-- List -->
    <List @tab="
      (value) => {
        selectTab(value);
      }
    " v-if="switch_tab == 'list'"></List>
    <!-- Contacts -->
    <Contacts @tab="
      (value) => {
        selectTab(value);
      }
    " v-if="switch_tab == 'contacts'"></Contacts>
  </div>
</template>
<script>
import List from "@/views/Accounts/Accounts.vue";
import Contacts from "@/views/Accounts/Contacts.vue";
export default {
  name: "Accounts",
  components: {
    List,
    Contacts,
  },
  data() {
    return {
      switch_tab: "list",
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      if (val) {
        vm.switch_tab = val;
      } else {
        vm.switch_tab = "list";
      }
    },
  },
  computed: {},
  mounted() {
    let vm = this;
    let path = [
      {
        label: "Accounts",
      },
    ];
    vm.$store.commit("SET_PATH", path);
    if (vm.$route.params.type) {
      vm.switch_tab = vm.$route.params.type;
    }
  },
  methods: {
    selectTab(type) {
      let vm = this;
      let path = [];
      if (type == "contacts") {
        path = [
          {
            label: "Account",
            path: "/accounts/list",
          },
          {
            label: type,
            active: true,
          },
        ];
      } else if (type == "list") {
        path = [
          {
            label: "Account",
          },
        ];
      }
      vm.$store.commit("SET_PATH", path);
      vm.$router
        .push({
          name: "accounts",
          params: { type: type },
        })
        .catch((error) => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
}
</style>
